"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GroupAddMembersModal = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _modal = _interopRequireWildcard(require("@insided/deprecated-preact-components/design-system-components/modal"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _UserSelector = _interopRequireDefault(require("@insided/deprecated-preact-components/user-selector/UserSelector"));

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _service = require("./service");

var _publish = _interopRequireDefault(require("@insided/deprecated-components/tracker/publish"));

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _GroupInvitationLink = _interopRequireDefault(require("./GroupInvitationLink"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DEFAULT_CURRENT_PAGE = 1;
var DEFAULT_PAGE_SIZE = 100;

var GroupAddMembersModal = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(GroupAddMembersModal, _Component);

  var _super = _createSuper(GroupAddMembersModal);

  function GroupAddMembersModal() {
    var _this;

    (0, _classCallCheck2.default)(this, GroupAddMembersModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "userId", (0, _insidedDataStorage.getInsidedData)('user').userid);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      users: [],
      addingMembers: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "addMembers", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var users, _this$props$showMessa, _this$props, _this$props$onAdd, _this$props2, _iterator, _step, user;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              users = _this.state.users;

              _this.setState({
                addingMembers: true
              });

              _context.prev = 2;
              _context.next = 5;
              return (0, _service.addMembers)({
                groupId: _this.props.groupId,
                data: {
                  usersToAdd: users.map(function (u) {
                    return u.id;
                  }),
                  communityUrl: (0, _globals.default)('communityUrl')
                }
              });

            case 5:
              _iterator = _createForOfIteratorHelper(users);

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  user = _step.value;

                  _publish.default.trackEvent('userevent', {
                    type: 'GroupMemberJoined',
                    payload: 'method2',
                    userId: user.id,
                    addedBy: _this.userId
                  });
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }

              _publish.default.trackEvent('userevent', {
                type: 'GroupMembersAdded',
                payload: users.length
              });

              (_this$props$showMessa = (_this$props = _this.props).showMessage) === null || _this$props$showMessa === void 0 ? void 0 : _this$props$showMessa.call(_this$props, 'success', (0, _preact.h)(_phrase.default, {
                p: _this.state.users.length > 1 ? 'groups.users.added' : 'groups.user.added'
              }));
              (_this$props$onAdd = (_this$props2 = _this.props).onAdd) === null || _this$props$onAdd === void 0 ? void 0 : _this$props$onAdd.call(_this$props2);

              _this.props.onClose();

            case 11:
              _context.prev = 11;

              _this.setState({
                addingMembers: false
              });

              return _context.finish(11);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2,, 11, 14]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchMembers", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(searchValue) {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", (0, _service.fetchMembers)({
                  groupId: _this.props.groupId,
                  page: DEFAULT_CURRENT_PAGE,
                  pageSize: DEFAULT_PAGE_SIZE,
                  searchString: searchValue
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "customFetch", /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(searchValue, url, responseKey) {
        var _yield$Promise$all, _yield$Promise$all2, users, members;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return Promise.all([(0, _service.fetchUsers)(url, responseKey), _this.fetchMembers(searchValue)]);

              case 2:
                _yield$Promise$all = _context3.sent;
                _yield$Promise$all2 = (0, _slicedToArray2.default)(_yield$Promise$all, 2);
                users = _yield$Promise$all2[0];
                members = _yield$Promise$all2[1];
                return _context3.abrupt("return", users.map(function (user) {
                  var isMember = members.members.some(function (member) {
                    return member.id === user.id;
                  });
                  return _objectSpread(_objectSpread({}, user), {}, {
                    className: isMember ? 'is-member' : '',
                    descriptionSlot: isMember ? (0, _preact.h)("span", {
                      className: "add-members-modal_member-sign"
                    }, "(", (0, _preact.h)(_phrase.default, {
                      p: "groups.add.members.in.group"
                    }), ")") : null,
                    disabled: isMember
                  });
                }));

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x2, _x3, _x4) {
        return _ref3.apply(this, arguments);
      };
    }());
    return _this;
  }

  (0, _createClass2.default)(GroupAddMembersModal, [{
    key: "onUsersChange",
    value: function onUsersChange(users) {
      this.setState({
        users: users
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          users = _this$state.users,
          addingMembers = _this$state.addingMembers;
      var _this$props3 = this.props,
          onClose = _this$props3.onClose,
          groupId = _this$props3.groupId,
          communityLocale = _this$props3.communityLocale;
      return (0, _preact.h)(_modal.default, {
        onClose: onClose,
        customClass: "group-add-members-modal"
      }, (0, _preact.h)(_modal.ModalHeader, {
        title: (0, _preact.h)("span", null, (0, _preact.h)(_phrase.default, {
          p: "groups.add.group.members.title"
        }))
      }), (0, _preact.h)(_modal.ModalBody, null, (0, _preact.h)("div", {
        className: "groups-add-members-modal"
      }, (0, _preact.h)("div", {
        className: "add-members-modal_description"
      }, (0, _preact.h)(_phrase.default, {
        p: "groups.add.members.description"
      })), (0, _preact.h)("div", {
        className: "add-members-modal_input-label"
      }, (0, _preact.h)(_phrase.default, {
        p: "groups.add.members"
      })), (0, _preact.h)(_UserSelector.default, {
        url: "/member/_searchAllUser?query=",
        customFetch: this.customFetch,
        placeholder: "Type usernames...",
        onChange: function onChange(users) {
          return _this2.onUsersChange(users);
        },
        searchActiveUsersOnly: true,
        error: false
      }), !users.length ? (0, _preact.h)(_GroupInvitationLink.default, {
        groupId: groupId,
        communityLocale: communityLocale
      }) : null)), (0, _preact.h)(_modal.ModalFooter, null, users.length ? (0, _preact.h)("div", {
        className: "add-members-modal_buttons"
      }, (0, _preact.h)(_Button.default, {
        size: "medium",
        className: "add-members-modal_cancel-btn",
        onClick: onClose,
        isLoading: addingMembers
      }, (0, _preact.h)(_phrase.default, {
        p: "groups.cancel"
      })), (0, _preact.h)(_Button.default, {
        size: "medium",
        className: "add-members-modal_add-btn",
        disabled: !users.length,
        onClick: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
          return _regenerator.default.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return _this2.addMembers();

                case 2:
                  return _context4.abrupt("return", _context4.sent);

                case 3:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        })),
        isLoading: addingMembers
      }, (0, _preact.h)(_phrase.default, {
        p: "groups.add"
      }))) : null));
    }
  }]);
  return GroupAddMembersModal;
}(_preact.Component);

exports.GroupAddMembersModal = GroupAddMembersModal;
var _default = GroupAddMembersModal;
exports.default = _default;